import { HTTPService } from './httpService';

const API = new HTTPService();

/**
 * The seeded area-formula defaults, keyed by coverage level.
 *
 * These ARE the formula templates in Phase A - the server copies the selected
 * coverage's `area_formula` onto the new service at create, and never re-seeds
 * it afterwards. That copy-on-create is why changing a service's coverage later
 * is unsafe: the structure does not follow.
 *
 * The response is enveloped and has carried both a bare array and a
 * `{ defaults, evaluation }` object during development, so unwrap defensively.
 * `evaluation` is documentation for implementers - the order of operations and
 * the unit of each variable - and is deliberately not returned here; the client
 * already encodes that order in `marineCalc.computeMarineArea`.
 */
export const getCoverageDefaults = async () => {
  const { data } = await API.get('/api/marine/coverage-defaults');
  const payload = data?.data ?? data;
  if (Array.isArray(payload)) return payload;
  if (Array.isArray(payload?.defaults)) return payload.defaults;
  if (Array.isArray(payload?.coverage_defaults)) return payload.coverage_defaults;
  if (payload) {
    console.warn('getCoverageDefaults: unrecognised response envelope shape', payload);
  }
  return [];
};

const areaFormulaService = { getCoverageDefaults };
export default areaFormulaService;
